import { InputProps, MenuItem, OutlinedInputProps, TextField, TextFieldProps } from "@mui/material";
import { ChangeEvent, ComponentPropsWithoutRef } from "react";
import { Controller, FieldValues, useFormContext } from "react-hook-form";

import styles from "./FormSelect.module.scss";

type IRefactorFormSelectProps = {
    name: string;
    label?: string;
    options: { label: string; value: string | number; disabled?: boolean }[];
    multiple?: boolean;
    renderValue?: (selected: unknown) => React.ReactNode;
    otherInputProps?: TextFieldProps;
    InputProps?: Partial<OutlinedInputProps | InputProps>;
} & ComponentPropsWithoutRef<typeof TextField>;

export const MRefactorSelect = (inputProps: IRefactorFormSelectProps) => {
    const { options, onChange, required = true, value, variant, multiple, renderValue, ...otherInputProps } = inputProps;

    return (
        <TextField
            onChange={onChange}
            value={value}
            fullWidth
            required={required}
            variant={variant}
            {...(variant === "filled" && {
                InputProps: { disableUnderline: true },
            })}
            select
            className={styles.customSelect}
            SelectProps={{
                multiple: multiple,
                renderValue: renderValue,
                MenuProps: {
                    PaperProps: {
                        style: {
                            maxHeight: "268px",
                        },
                    },
                },
            }}
            {...otherInputProps}
        >
            {options.map((option) => (
                <MenuItem key={option.label} value={option.value} disabled={option?.disabled}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

const RefactorFormSelect = (inputProps: IRefactorFormSelectProps) => {
    const { name, options, defaultValue, error, onChange, multiple, renderValue, ...otherInputProps } = inputProps;

    const { control } = useFormContext<FieldValues>();

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange && onChange(e);
    };

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field: { onChange, value }, fieldState: { error }, formState }) => {
                return (
                    <MRefactorSelect
                        variant="filled"
                        name={name}
                        value={value}
                        onChange={(e) => {
                            // 處理多選和單選的值
                            const target = e.target as HTMLInputElement | HTMLSelectElement;
                            const nextValue = target.value;
                            onChange(nextValue);
                            handleChange(e);
                        }}
                        options={options}
                        error={!!error}
                        helperText={error ? error.message : null}
                        multiple={multiple}
                        renderValue={renderValue}
                        {...otherInputProps}
                    />
                );
            }}
        />
    );
};

export default RefactorFormSelect;